<div>
	<ng-container *ngFor="let formItem of setUserForm">
		<div class="input-line mt-3">
			<div class="header-line">{{ labels.lbl_asset_info_usuario }}</div>
		</div>

		<div class="input-container">
			<div class="input-line">
				<span>{{ labels.lbl_geral_usuario }}</span>
				<span><input type="text" [placeholder]="labels.lbl_geral_usuario" [value]="formItem.fullName" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_geral_email }}</span>
				<span><input type="email" [placeholder]="labels.lbl_geral_email" [value]="formItem.email" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_login_usuario }}</span>
				<span><input type="text" [placeholder]="labels.lbl_login_usuario" [value]="formItem.login" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_geral_tel_celular }}</span>
				<span><input type="tel" [placeholder]="labels.lbl_geral_tel_celular" [value]="formItem.mobile" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_geral_telefone }}</span>
				<span><input type="tel" [placeholder]="labels.lbl_geral_telefone" [value]="formItem.phone" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_general_registration }}</span>
				<span><input type="text" [placeholder]="labels.lbl_general_registration" [value]="formItem.uniquekey" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_geral_local }}</span>
				<span><input type="text" [placeholder]="labels.lbl_geral_local" [value]="formItem.location" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_asset_inventario_endereco }}</span>
				<span><input type="text" [placeholder]="labels.lbl_asset_inventario_endereco" [value]="formItem.locale" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_asset_inventario_estado }}</span>
				<span><input type="text" [placeholder]="labels.lbl_asset_inventario_estado" [value]="formItem.site" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_geral_depto }}</span>
				<span><input type="text" [placeholder]="labels.lbl_geral_depto" [value]="formItem.department" disabled /></span>
			</div>
			<div class="input-line">
				<span>{{ labels.lbl_supervisor }}</span>
				<span><input type="text" [placeholder]="labels.lbl_supervisor" [value]="formItem.supervisor" disabled /></span>
			</div>
			<div class="input-line">
				<span>Descrição</span>
				<span><input type="text" placeholder="Descrição" [value]="formItem.description" disabled /></span>
			</div>
		</div>
	</ng-container>
</div>
<div class="loading-container" *ngIf="isLoadingModal">
	<cpi-dot-bounce-loading-effect></cpi-dot-bounce-loading-effect>
</div>
